// Configure FirebaseUI.
export const authUiConfig = {
  // Popup signin flow rather than redirect flow.
  signInFlow: "popup",
  // Redirect to / after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
  signInSuccessUrl: "/",
  // We will display Google and Facebook as auth providers.
  signInOptions: [],
};

const PROVIDERS = {
  GoogleAuthProvider: "GoogleAuthProvider",
  EmailAuthProvider: "EmailAuthProvider",
};

// 要提供驗證的方式
export const authProvider = [
  PROVIDERS.GoogleAuthProvider,
  // PROVIDERS.EmailAuthProvider,
];
